import React from 'react';
import ApiLink from './ApiLink';

import './Sidebar.css';
import OktaLoggedInAs from './OktaLoggedInAs';

function groupBy(list, keyFn) {
  const dict = {};
  for (const item of list) {
    const key = keyFn(item);
    dict[key] = dict[key] || [];
    dict[key].push(item);
  }
  return dict;
}

const lobs = {
  marketdata: 'Market Data',
  trading: 'Trading',
};

const Sidebar = ({ apis }) => {
  const toApiLink = (api, i) => <ApiLink key={i} api={api} />;
  const byName = (a, b) => (a.name < b.name ? -1 : 1);

  const grouped = groupBy(apis.sort(byName), ({ url }) => url.split('/')[2]);

  return (
    <div className="SideBar">
      <div className="SideBar-header">
        <h1>Service Docs</h1>
      </div>
      <div className="SideBar-body">
        <OktaLoggedInAs />
        {Object.entries(grouped).map(([lob, apis]) => (
          <div key={lob}>
            <h3>{lobs[lob] || lob} Services</h3>
            {apis.map(toApiLink)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
